<template>
      <div class="row open-invoices-payment-section">
        <div id="invoices-table" class="col-sm-12 materialized">
          <vue-good-table
            :columns="columns"
            :rows="openInvoicesArray"
            :paginate="true"
            :rowsPerPageText="mkPaymentData.rowsPerPageText"
            :showFootText="true"
            :footLabel="tfooter.label"
            :footValue="totalValue"
            :nextText="mkPaymentData.nextText"
            :prevText="mkPaymentData.prevText"
            :perPage="5"
            styleClass="table condensed table-hover">
            <template slot="custom-columns" slot-scope="props">
                <th :class="props.columnHeaderClass(columns[0], 0).replace('sorting', '')" :style="{width: columns[0].width ? columns[0].width : 'auto'}" v-if="!columns[0].hidden && agreementData.kindOfPayment === 'card'">
                    <el-checkbox role="button" id="select-all-agreements" v-model="selectAll"></el-checkbox>
                </th>
                <th v-for="(column, index) in props.columns.slice(-props.columns.length + 1)" @click="props.sort(index + 1)" :class="props.columnHeaderClass(column, index + 1)" :style="{width: column.width ? column.width : 'auto'}" v-if="!column.hidden">
                    <span>{{column.label}}</span>
                </th>
            </template>
            <template slot="table-row" slot-scope="props">
              <td class="text-center materialized" data-title='' v-if="agreementData.kindOfPayment === 'card'">
                <el-checkbox role="button" @change="value => addAgreement(value, props.row.idReferential)" :value="getCheckBoxValue(props)"></el-checkbox>
              </td>
              <td class="text-left" data-title='Member'><span class="data-item">
                {{props.row.memberNumber === agreementData.agreementEFTs[0].agreementId ? '★ ' : ''}}
                {{ props.row.memberName }}
              </span></td>
              <td class="text-center" data-title='Date'><span class="data-item">{{ props.row.date }}</span></td>
              <td class="text-center" data-title='Agreement'>
                  <span class="data-item">{{ props.row.agreement }}</span><br>
                  <span class="data-item">({{ props.row.agreementDescription}})</span>
              </td>
              <td class="text-center" data-title='Reference Number'><span class="data-item">{{ props.row.referenceNumber
                }}</span></td>
              <td class="text-center" data-title='Description'><span class="data-item"
                                                                     v-bind:class="{'payment-done-color': props.row.balance < 0}">{{ props.row.description}}</span>
              </td>
              <td class="text-right" data-title='Balance'>
                <span class="data-item brand-24-green" v-bind:class="{'payment-done-color': props.row.balance < 0}">{{ '$' + props.row.balance.toFixed(2) }}</span>
              </td>
            </template>
          </vue-good-table>
        </div>
      </div>
</template>

<script>
  import _ from 'lodash'
  import { StringUtils } from 'my-account-common'

  export default {
    name: 'invoicesTable',
    props: {
      agreementData: {
        type: Object,
        required: true
      },
      openInvoicesArray: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        selectedAgreements: [],
        mkPaymentData: {
          rowsPerPageText: 'Rows: ',
          nextText: '',
          prevText: ''
        },
        tfooter: {
          label: 'Total Balance:',
          value: '0.00'
        },
        columns: [
          {
            label: '',
            field: 'selected',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Member',
            field: 'memberName',
            sortable: true
          },
          {
            label: 'Date',
            field: 'date',
            type: 'date',
            tdClass: 'text-center',
            thClass: 'text-center',
            html: '<span class="title" data-title="Date"></span>',
            sortable: true
          },
          {
            label: 'Agreement',
            field: 'agreement',
            tdClass: 'text-center',
            thClass: 'text-center',
            sortable: true
          },
          {
            label: 'Reference Number',
            field: 'referenceNumber',
            tdClass: 'text-center',
            thClass: 'text-center',
            sortable: true
          },
          {
            label: 'Description',
            field: 'description',
            tdClass: 'text-center',
            thClass: 'text-center',
            sortable: true
          },
          {
            label: 'Balance',
            field: 'balance',
            type: 'decimal',
            tdClass: 'text-center',
            thClass: 'text-center',
            sortable: false
          }]
      }
    },
    beforeMount () {
      this.setIdReferential()
    },
    mounted () {
      this.selectAll = true
    },
    methods: {
      setIdReferential () {
        this.openInvoicesArray.forEach((openInvoice, index) => {
          openInvoice.memberName = StringUtils.initCaps(openInvoice.memberName)
          openInvoice.idReferential = 'inv-' + index
        })
      },
      addAgreement (value, workWith) {
        if (!value.target.checked) {
          this.selectedAgreements = this.selectedAgreements.filter(function (name) {
            return name !== workWith
          }).map(value => value)
        } else {
          this.selectedAgreements.push(workWith)
        }
        this.$emit('change', this.selectedAgreements)
        this.$forceUpdate()
      },
      getCheckBoxValue (props) {
        if ((this.filteredMember !== '') && (props.row.check === false)) {
          return false
        }
        return this.selectedAgreements.indexOf(props.row.idReferential) > -1
      }
    },
    computed: {
      totalValue: {
        get: function () {
          return '$' + _.sumBy(this.openInvoicesArray, 'balance').toFixed(2)
        }
      },
      selectAll: {
        get: function () {
          return this.selectedAgreements.length === this.openInvoicesArray.length
        },
        set: function (value) {
          this.selectedAgreements = []
          if (value) {
            this.selectedAgreements = this.openInvoicesArray.map(function (agreement) {
              return agreement.idReferential
            })
          }
          this.$emit('change', this.selectedAgreements)
          this.$forceUpdate()
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '~CommonBilling/css/variables';

  .payments-desc-header {
    font-family: "ApexMedium", "HelveticaNeue", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
    font-size: 18px;
    margin-top: 18px;
  }

  .payment-container .edit-form {
    padding: 10px 15px;
    background-color: #f5f5f5;
    margin: 0;
  }

  .overdue-card {
    color: red;
  }

  .open-invoices-payment-section .table-footer .datatable-length {
    display: none;
  }

  /* Small devices (phones under 768px) */
  @media (max-width: $screen-sm-min) { }

  /* Small devices (tablets, 768px and up) */
  @media (min-width: $screen-sm-min) { }

  /* Medium devices (desktops, 992px and up) */
  @media (min-width: $screen-md-min) { }

  /* Large devices (large desktops, 1200px and up) */
  @media (min-width: $screen-lg-min) { }

  @media only screen and (max-width: 600px) { }

  @media only screen and (max-width: 750px) { }
</style>



// WEBPACK FOOTER //
// node_modules/UpdatePaymentMethods/updateOpenInvoices/UpdateOpenInvoicesTable.vue